import { deserialize, deserializeWith, rename, t } from "desero";
import { Meal } from "~/models";

/**
 * Menu of a specific date with meals details.
 * @hideconstructor
 */
export class Menu {
  /**
   * For when this menu is made for.
   */
  @deserializeWith((date) => new Date(date))
  public date = t.instance<Date>();

  /**
   * Meals available in this menu.
   */
  @rename("repas")
  @deserializeWith((repas) => {
    if (Array.isArray(repas)) {
      return repas.map((repas) => deserialize(Meal, repas));
    }

    return [deserialize(Meal, repas)];
  })
  public meals = t.array(t.reference(Meal));
}
